import React from "react";
import { Link } from "react-router-dom";
import bgheader5png from "../../../assets/images/bg-header-5.png";

function License(props) {
  return (
    <>
      <header class="dx-header dx-box-5">
        <div class="container">
          <div class="bg-image bg-image-parallax">
            <img src={bgheader5png} class="jarallax-img" alt="" />
            <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
          </div>
          <div class="container mnb-8">
            <h1 class="h4 mb-10 text-white text-center">Items & Licenses</h1>

            <ul class="dx-breadcrumbs text-center">
              <li>
                <Link to="/index">Home</Link>
              </li>
              <li>Items &amp; Licenses</li>
            </ul>
          </div>
        </div>
      </header>
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="dx-box-decorated">
                <div className="table-responsive">
                  <table className="dx-table dx-table-default">
                    <thead>
                      <tr>
                        <th scope="col">Item</th>
                        <th scope="col">License Key</th>
                        <th scope="col">License</th>
                        <th scope="col">Website</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row" className="dx-table-default-product">
                          <Link to="/product">
                            Quantial – Moving Upon Signs Moveth Lesser
                          </Link>
                        </th>
                        <td className="dx-table-licenseKey">
                          98vbjy-t46879ug-fd9iytvh-578g0-8ubfyj00
                        </td>
                        <td>Standard</td>
                        <td className="dx-table-website dx-table-default-website">
                          <Link to="/#">https://example.info/</Link>
                        </td>
                        <td>21.07.2018</td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-default-product">
                          <Link to="/product">
                            Sensific – Saying Beast Lesser for in Fruitful
                          </Link>
                        </th>
                        <td className="dx-table-licenseKey">
                          98vbjy-t46879ug-fd9iytvh-578g0-8ubfyj00
                        </td>
                        <td>Extended</td>
                        <td className="dx-table-website dx-table-default-website">
                          Not activated
                        </td>
                        <td>18.07.2018</td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-default-product">
                          <Link to="/product">
                            Minist – Subdue Above for Signs Dry is Have Great
                          </Link>
                        </th>
                        <td className="dx-table-licenseKey">
                          98vbjy-t46879ug-fd9iytvh-578g0-8ubfyj00
                        </td>
                        <td>Standard</td>
                        <td className="dx-table-website dx-table-default-website">
                          <Link
                            to="/#"
                            className="dx-btn dx-btn-md dx-btn-grey-2"
                          >
                            Deactivate
                          </Link>
                        </td>
                        <td>18.07.2018</td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-default-product">
                          <Link to="/product">
                            Desty – She'd Under Light Over Multiply Stars Winged
                          </Link>
                        </th>
                        <td className="dx-table-licenseKey">
                          98vbjy-t46879ug-fd9iytvh-578g0-8ubfyj00
                        </td>
                        <td>Extended</td>
                        <td className="dx-table-website dx-table-default-website">
                          Not activated
                        </td>
                        <td>15.07.2018</td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-default-product">
                          <Link to="/product">
                            Silies – Grass Living Fly Subdue After Fruitful
                          </Link>
                        </th>
                        <td className="dx-table-licenseKey">
                          98vbjy-t46879ug-fd9iytvh-578g0-8ubfyj00
                        </td>
                        <td>Extended</td>
                        <td className="dx-table-website dx-table-default-website">
                          Not activated
                        </td>
                        <td>03.07.2018</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default License;
